import { render } from "./Privileges.vue?vue&type=template&id=349f81a0&scoped=true"
import script from "./Privileges.vue?vue&type=script&lang=js"
export * from "./Privileges.vue?vue&type=script&lang=js"

import "./Privileges.vue?vue&type=style&index=0&id=349f81a0&scoped=true&lang=css"
import "./Privileges.vue?vue&type=style&index=1&id=349f81a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349f81a0"]])

export default __exports__